module.exports = __webpack_public_path__ + "static/email-list-management-trophy-2453244a655a11e2763f3d322af8bb82.svg";